import React from 'react';

import styled from '@emotion/styled';
import { Radio as ARadio, RadioGroupProps, RadioProps } from 'antd';

const { Group: ARadioGroup } = ARadio;

export interface IRadioParams extends RadioProps {}

export interface IRadioGroupParams extends RadioGroupProps {}

export const Radio = styled(ARadio)`
  /* 요소시작: &label.ant-radio-wrapper.ant-radio-wrapper-checked*/
  /* default */
  .ant-radio + span {
    padding-left: 6px;
  }
  /* checked */
  .ant-radio.ant-radio-checked {
    .ant-radio-inner {
      border-color: ${({ theme }) => theme.link2};
    }
    .ant-radio-inner::after {
      background-color: ${({ theme }) => theme.link2};
    }
  }
  /* disabled */
  .ant-radio.ant-radio-disabled {
    .ant-radio-inner {
      background-color: ${({ theme }) => theme.gray3};
      border-color: ${({ theme }) => theme.gray4} !important;
    }
    .ant-radio-inner::after {
      background-color: ${({ theme }) => theme.gray4};
    }
  }
  .ant-radio.ant-radio-disabled + span {
    color: ${({ theme }) => theme.gray4};
  }
`;

const StyledRadioGroup = styled(ARadioGroup)<IRadioGroupParams>`
  width: 100%;
  border: 0;
  border-radius: 2px;
`;

export const RadioGroup = ({ children, ...rest }: IRadioGroupParams) => (
  <StyledRadioGroup {...rest}>{children}</StyledRadioGroup>
);
